<div
  class="stacked-bar"
  [style.height.px]="height()"
  [attr.role]="ariaLabel() ? 'img' : null"
  [attr.aria-label]="ariaLabel() || null"
>
  @for (segment of segments(); track $index) {
    <div
      class="stacked-bar__segment"
      [style.width]="width(segment.value)"
      [style.background]="background(segment.colorVar)"
      aria-hidden="true"
    ></div>
  }
</div>
